export class DateFormatUtils {

    //Useful in Safari and IE because inputs of type date are not supported
    public static formatDate(date: string): string {
        const numbers = date.split('/');
        return numbers[2] + '-' + numbers[1] + '-' + numbers[0];

    }

    public static formatDateToDisplay(date: string): string {
        const numbers = date.split('-');
        return numbers[2] + '/' + numbers[1] + '/' + numbers[0];
    }

    public static formatISODate(date: string) {
        const isoDate = date.indexOf("/") > -1 ? this.formatDate(date) : date;
        const today = new Date();
        let clientZone = today.toString().substr(28, 5);
        clientZone = clientZone.slice(0, 3) + ':' + clientZone.slice(3);
        return isoDate === this.todayToStringDate() ? isoDate + 'T' + today.toLocaleTimeString("en-US", { hour12: false }) + clientZone : isoDate + 'T00:00:00' + clientZone;
    }

    public static todayToStringDate(): string {
        return new Date().getFullYear() +
            "-" +
            ("0" + (new Date().getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + new Date().getDate()).slice(-2);
    }
}